import {
  get,
  post,
  del,
  getfile
} from '@/http/request'
import {
  HOST
} from '@/http/config'

console.log(HOST, 'url')

// test
export function top250(params) {
  return get(`${HOST}v2/movie/top250`, params)
}
// 我的待办任务
export function getMyTasks(params) {
  return get(`${HOST}activity/process_handler/getMyTasks`, params)
}
// 我的已办任务
export function getMyTasksistory(params) {
  return get(`${HOST}activity/process_handler/getMyTasksistory`, params)
}
// 上传单个文件
export function saveFile(params) {
  return post(`${HOST}mongo/saveFile`, params)
}

// 通过id获取文件信息
export function getFile(fileId) {
  return getfile(`${HOST}mongo/kkFile`, { fileId })
}
// 获取用户信息
export function sendMobile(phone) {
  return get(`${HOST}login/sendMobile/${phone}`)
}
// 获取验证码
export function queryLoginUser() {
  return get(`${HOST}login/queryLoginUser`)
}
// 密码登录
export function authenticationForm(params) {
  return post(`${HOST}authentication/form`, params)
}
// 验证码登录
export function authenticationMobile(params) {
  return post(`${HOST}authentication/mobile`, params)
}
//获取分组列表
export function gGroupList(params) {
  return get(`${HOST}sys-group/list`, params)
}
// 获取组织机构树
export function getorganizeList() {
  return get(`${HOST}organization-info/treeList/`)
}
//根据类型查询字典下拉列表
export function listByType(params) {
  return get(`${HOST}sys-dict/listByType`, params)
}
// 审批流 渲染表单信息
export function formDataShow(params) {
  return get(`${HOST}activity/process_handler/formDataShow`, params)
}
// 审批流 完成待办任务
export function completeTask(params) {
  return post(`${HOST}activity/process_handler/completeTask`, params)
}
// 审批流 根据 流程实例id 获取审批流程图
export function getDefinitionXMLByProcessInstanceId(params) {
  return get(`${HOST}activity/process_handler/getDefinitionXMLByProcessInstanceId`, params)
}
// 审批流 审批流程图
export function getDefinitionXML(params) {
  return get(`${HOST}activity/process_handler/getDefinitionXML`, params)
}
// 审批流 审批流程图 高亮节点
export function gethighLineProcess(params) {
  return get(`${HOST}activity/process_handler/gethighLineProcess`, params)
}
//根据名字搜索用户
export function queryList(params) {
  return get(`${HOST}sys-user/queryList`, params)
}
// 获取左侧菜单权限
export function queryUserMenuList(params) {
  return get(`${HOST}login/queryUserMenuList`, params)
}
// 获取简报页头
export function SysHeader(params) {
  return get(`${HOST}sys-header/list`, params)
}
// 生成二维码
export function generCode(params) {
  return post(`${HOST}qr-code/generCode`, params)
}
//修改密码
export function updatePassword(params) {
  return post(`${HOST}login/updatePassword`, params)
}
// 获取用户使用机构列表
export function getorganizationUser() {
  return get(`${HOST}organization-user/list`)
}
// 已提交 未审核 可撤回流程
export function recallProcess(params, recallUrl) {
  return get(`${HOST + recallUrl}/recallProcess`, params)
}
// 发票查重
export function invoiceDistinct(params) {
  return get(`${HOST}medical-reimbursement-batch/invoiceDistinct`, params)
}
// 报销类型
export function getReimbursementType(params) {
  return get(`${HOST}reimbursement-type/dropDown`, params)
}



// WEBPACK FOOTER //
// ./src/http/url.js